import { get } from "lodash";
import React from "react";
import {
	AutocompleteInput,
	BooleanInput,
	ReferenceInput,
	required,
	TextInput,
} from "react-admin";
import { useForm, useFormState } from "react-final-form";
import LandingInput from "../../channels/inputs/LandingInput";
import RaInput from "../../components/inputs/RaInput";
import { usersConfig } from "../../users";
import Single from "./Single";

const Switch = (props) => {
	const form = useForm();
	const formState = useFormState();
	const isBulk = get(formState, "values.is_bulk", false);
	const userId = get(formState, "values.user_id");
	const handleChange = (value) => {
		form.batch(() => {
			if (value === true) {
				form.change("remote_name", null);
				form.change("remote_id", null);
				form.change("name", null);
				form.change("user_id", null);
				form.change("bookmaker_landing_id", null);
			} else {
				form.change("bulk_remotes", null);
			}
		});
	};
	return (
		<React.Fragment>
			<RaInput>
				<BooleanInput onChange={handleChange} source="is_bulk" {...props} />
			</RaInput>
			{!isBulk ? (
				<React.Fragment>
					<Single {...props} />
					<RaInput>
						<ReferenceInput
							{...props}
							source="user_id"
							reference="users"
							filter={{ status: "active" }}
							allowEmpty
							{...usersConfig.reference}
						>
							<AutocompleteInput optionText="name" />
						</ReferenceInput>
					</RaInput>
					{userId && (
						<RaInput>
							<LandingInput
								{...props}
								source="bookmaker_landing_id"
								validate={required()}
								fullWidth
							/>
						</RaInput>
					)}
				</React.Fragment>
			) : (
				<RaInput>
					<TextInput
						{...props}
						fullWidth
						rows={10}
						multiline
						source="bulk_remotes"
						label="resources.bookmaker-channels.fields.bulk_remotes"
						helperText="resources.bookmaker-channels.fields.bulk_remotes.help"
						validate={required()}
					/>
				</RaInput>
			)}
		</React.Fragment>
	);
};

export default Switch;
